module.exports = __webpack_public_path__ + "static/img/other8.d734c3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other8.png
// module id = 7E1u
// module chunks = 1